import React, { createContext, useContext } from "react";
import { Dialog, DialogType } from "@fluentui/react/lib/Dialog";
import { Card, List, Tooltip } from "antd";

import { ExternalLink, PenTool, Play, Pocket, Server } from "react-feather";
import { ContextualMenu } from "@fluentui/react";
import MainStore from "../../store/mainStore";
import NaocDailyProductionStore from "../../../productiondata/store/naocdailyproductionstore";
import EbendoDailyProductionStore from "../../../productiondata/store/ebendodailyproductionstore";
import QuaiboDailyProductionStore from "../../../productiondata/store/quaibodailyproductionstore";
import MonthlyPerformanceStore from "../../../monthly-performance/store/monthlyperformancestore";
import { useNavigate } from "react-router-dom";
import "../../style/globallink.css";

import { observer } from "mobx-react-lite";
const mainstore = createContext(MainStore);
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
const dragOptions = {
  moveMenuItemText: "Move",
  closeMenuItemText: "Close",
  menu: ContextualMenu,
};
const dialogContentProps = {
  type: DialogType.close,
  title: "Production Management",
  subText:
    "Choose the production module you want to access and naigate quickly to the selected module",
};
const menuData = [
  {
    title: "NAOC  Production",
    desc: "Upload Naoc Daily production from the field using Naoc Input Deck or manual field entry",
    icon: <PenTool size={"72"} color="#3D3F96" />,
    link: "",
    value: 1,
  },
  {
    title: "EBENDO  Production",
    desc: "Upload Ebendo Daily production from the field using Ebendo Input Deck or manual field entry",
    icon: <Pocket size={"72"} color="#E03136" />,
    value: 2,
  },
  {
    title: "QUAIBO  Production",
    desc: "Upload Quaibo Daily production from the field using Quaibo Input Deck or manual field entry",
    icon: <Play size={"72"} color="#FFCC2A" />,
    value: 3,
  },
  {
    title: "NAOC Monthly Production",
    desc: "Upload Naoc Monthly production from the field using Naoc Monthly productionInput Deck ",
    icon: <Server size={"72"} color="#FBA832" />,
    value: 4,
  },
];

export const ProductionManagement = observer(() => {
  const mainStore = useContext(mainstore);
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  const navigate = useNavigate();
  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,

      dragOptions: dragOptions,
    }),
    []
  );
  return (
    <Dialog
      hidden={!mainStore.showProductionManagementGlobalLinkDialog}
      onDismiss={() => {
        mainStore.showProductionManagementGlobalLinkDialog = false;
      }}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      minWidth={"45%"}
    >
      <List
        grid={{ gutter: 20, column: 4 }}
        bordered={false}
        dataSource={menuData}
        itemLayout="horizontal"
        renderItem={(item) => (
          <List.Item>
            <Tooltip title={` ${item.desc} `}>
              <Card
                title={
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {item.icon}
                  </div>
                }
                style={{
                  cursor: "pointer",
                  backgroundColor: "white",
                  textAlign: "center",
                }}
                className="globallinks"
                onClick={async () => {
                  if (item.value !== 4) {
                    mainStore.assetContextId = item.value;
                    mainStore.assetContextName = mainStore.assets.get(
                      item.value
                    ).name;
                  } else {
                    mainStore.assetContextId = 1;
                    mainStore.assetContextName = mainStore.assets.get(1).name;
                  }

                  mainStore.showProductionManagementGlobalLinkDialog = false;
                  switch (item.value) {
                    case 1:
                      naocDailyProductionStore.showNaocDailyProductionDialog = true;

                      navigate("/productiondata/field-daily-production");
                      mainStore.menuSelectedKey = "3";
                      mainStore.menuOpenKey = "14";
                      break;
                    case 2:
                      ebendoDailyProductionStore.showEbendoDailyProductionDialog = true;
                      mainStore.menuSelectedKey = "3";
                      mainStore.menuOpenKey = "14";
                      navigate("/productiondata/field-daily-production");
                      break;
                    case 3:
                      quaiboDailyProductionStore.showQuaiboDailyProductionDialog = true;
                      mainStore.menuSelectedKey = "3";
                      mainStore.menuOpenKey = "14";
                      navigate("/productiondata/field-daily-production");
                      break;
                    case 4:
                      monthlyPerformanceStore.showNaocMonthlyProductionDialog = true;
                      mainStore.menuSelectedKey = "4";
                      mainStore.menuOpenKey = "14";
                      navigate("/monthly-performance/string-production");
                      break;
                    default:
                      break;
                  }
                }}
              >
                <div
                  style={{
                    textAlign: "center",

                    display: "flex",
                    color: "#0078d4",
                  }}
                >
                  {item.title} <ExternalLink size={12} />
                </div>
              </Card>
            </Tooltip>
          </List.Item>
        )}
      />
    </Dialog>
  );
});

